// frontend-react/src/components/Layout/Footer.js
import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  YouTube
} from '@mui/icons-material';
import { motion } from 'framer-motion';

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#0f172a' : '#1e293b',
  color: '#ffffff',
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(4),
  marginTop: theme.spacing(10),
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #6366f1, #ec4899, #6366f1)',
    backgroundSize: '200% 100%',
    animation: 'gradient 3s linear infinite',
  },
  '@keyframes gradient': {
    '0%': { backgroundPosition: '0% 50%' },
    '100%': { backgroundPosition: '200% 50%' },
  }
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#94a3b8',
  textDecoration: 'none',
  display: 'block',
  marginBottom: theme.spacing(1.5),
  transition: 'all 0.3s ease',
  fontSize: '0.95rem',
  '&:hover': {
    color: '#ffffff',
    transform: 'translateX(5px)',
  },
}));

const SocialButton = styled(IconButton)(({ theme }) => ({
  color: '#94a3b8',
  border: '1px solid rgba(255,255,255,0.1)',
  marginRight: theme.spacing(1),
  transition: 'all 0.3s ease',
  '&:hover': {
    color: '#ffffff',
    backgroundColor: 'rgba(255,255,255,0.1)',
    transform: 'translateY(-3px)',
  },
}));

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();

  const isDark = theme.palette.mode === 'dark';

  return (
    <footer style={{background:isDark?'#0D0D1A':'#F5F7FA',color:isDark?'#00FF00':'#00CFFF',padding:40,fontFamily:'monospace',textAlign:'center'}}>
      <div className="matrix-text">
        <p>VORTIX.DIGITAL // NOTICIAS DEL FUTURO</p>
        <p>© 2025 // TODOS LOS DERECHOS RESERVADOS</p>
      </div>
    </footer>
  );
};

export default Footer;
